if(!customElements.get('custom-faq')){
    class CustomFaq extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.faqDetailsContents = this.querySelectorAll(".faq-details-content");
            this.faqDetailsContents.forEach(content => {
               this.renderContentPageCTA(content);
            });

            this.categories = [];
            this.faqDetails = this.querySelectorAll(".faq-details");
            this.faqDetails.forEach(item => {
                const category = item.dataset.category;
                if(!this.categories.includes(category)){
                    this.categories.push(category);
                }
            });

            this.renderMainCTA();

            this.faqContent = this.querySelector(".faq__content");
            this.faqCtaContent = this.querySelector(".faq__cta-content");

            // load faq
            this.faqCTAItems = this.querySelectorAll('.faq-item');
            this.faqCTAItems.forEach(item => {
                item.querySelector(".subject").addEventListener("click", this.loadDetailsContent.bind(this));
                item.querySelector(".subject").addEventListener("keydown", e => {
                    if(e.key === 'Enter'){
                        this.loadDetailsContent(e);
                    }
                });
            });

            this.buttonBacks = this.querySelectorAll('.button-back');
            if(this.buttonBacks){
                this.buttonBacks.forEach(item => {
                    item.addEventListener("click", this.backToCTA.bind(this));
                    item.addEventListener("keydown", e => {
                        if(e.key === 'Enter'){
                            this.backToCTA();
                        }
                    });
                });
            }
        }

        renderMainCTA(){
            const template = this.querySelector('#faq-main-cta');

            this.categories.forEach(category => {
                const newDiv = document.createElement('div');
                newDiv.classList.add('faq__cta-column', 'border-current/20');

                const newHeading = document.createElement('h3');
                newHeading.classList.add('heading', 'py-4');
                newHeading.innerHTML = `<span>${category}</span>`;

                const childDiv = document.createElement('div');
                childDiv.classList.add('faq-items');

                this.faqDetails.forEach(item => {
                    if(item.dataset.category === category){
                        const faqQnaBlocks = item.querySelectorAll('.faq-details-content');
                        faqQnaBlocks.forEach(block => {
                            const clone = template.content.cloneNode(true);
                            const blockId = block.dataset.qnaBlockId;
                            clone.querySelector('.subject > span').innerHTML = block.querySelector('.faq-subject > span').innerHTML;

                            if(clone.querySelector('.answer') && block.querySelector(".faq-answer")){
                                clone.querySelector('.answer').innerHTML = block.querySelector(".faq-answer").innerHTML;
                            }
                            clone.querySelector('.faq-item').setAttribute('data-qna-block-id', blockId);
                            childDiv.appendChild(clone);
                        });
                    }
                });

                newDiv.appendChild(newHeading);
                newDiv.appendChild(childDiv);
                this.querySelector('.faq__cta-content').appendChild(newDiv);
            });
        }

        renderContentPageCTA(content){
            const subject = content.querySelector('.faq-subject > span').innerHTML;
            const answer = content.querySelector(".faq-answer").innerHTML;
            const blockId = content.dataset.qnaBlockId;

            const parent = content.closest('.faq-details');
            const template = parent.querySelector('template');
            const clone = template.content.cloneNode(true);

            clone.querySelector('.subject > span').innerHTML = subject;
            clone.querySelector(".answer").innerHTML = answer;
            clone.querySelector('.faq-item').setAttribute('data-qna-block-id',  blockId);

            const contentCategoryBlock = parent.querySelector(".faq-details-category");
            if(contentCategoryBlock){
                contentCategoryBlock.appendChild(clone);
            }

            // update category
            const category = parent.dataset.category;
            if(category && content.querySelector('.faq-details-content .faq-category')){
                content.querySelector('.faq-details-content .faq-category').innerHTML = category;
            }
        }

        loadDetailsContent(e){
            if(!e.currentTarget) return;

            const currentBlockId = e.currentTarget.closest('.faq-item').dataset.qnaBlockId;
            if(!currentBlockId) return;

            this.faqDetails.forEach(item => {
                const faqDetailsContent = item.querySelectorAll('.faq-details-content');
                let qnaBlockIncluded = false;
                faqDetailsContent.forEach(content => {
                    const parent = content.closest('.faq-details-content-block');
                    if(content.dataset.qnaBlockId === currentBlockId){
                        parent.setAttribute('aria-hidden', 'false');
                        parent.removeAttribute('inert');
                        qnaBlockIncluded = true;
                    } else {
                        parent.setAttribute('aria-hidden', 'true');
                        parent.setAttribute('inert', '');
                    }
                });

                if(qnaBlockIncluded){
                    item.setAttribute('aria-hidden', 'false');
                    item.removeAttribute('inert');
                } else {
                    item.setAttribute('aria-hidden', 'true');
                    item.setAttribute('inert', '');
                }
            });

            this.faqContent.setAttribute('aria-hidden', 'false');
            this.faqContent.removeAttribute('inert');

            this.faqCtaContent.setAttribute('inert', '');
            this.faqCtaContent.setAttribute('aria-hidden', 'true');
        }

        backToCTA(){
            this.loadCTA();
        }

        loadCTA(){
            this.faqContent.setAttribute("aria-hidden", "false");
            this.faqContent.removeAttribute("inert");

            this.faqCtaContent.removeAttribute('inert');
            this.faqCtaContent.setAttribute('aria-hidden', 'false');

            this.faqDetails.forEach(item => {
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('inert', '');
            });
        }
    }

    customElements.define('custom-faq', CustomFaq);
}